export enum SuggestionType {
  IMPROVEMENT = 'improvement',
  NEW_FEATURE = 'new_feature',
}
